import { color } from "@/styles/tokens";
import type { _SVGIcon } from "hsl-core/Components";

export const STROKE = color.border.ctaSecondary;

const body: _SVGIcon.IconBody = (params) => {
	const stroke = params?.stroke ?? STROKE;
	return `
    <path d="M13.2917 2.6665H3.95833C3.22195 2.6665 2.625 3.26346 2.625 3.99984V13.3332C2.625 14.0696 3.22195 14.6665 3.95833 14.6665H13.2917C14.028 14.6665 14.625 14.0696 14.625 13.3332V3.99984C14.625 3.26346 14.028 2.6665 13.2917 2.6665Z" stroke="${stroke}" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.292 1.3335V4.00016" stroke="${stroke}" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5.95801 1.3335V4.00016" stroke="${stroke}" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2.625 6.6665H14.625" stroke="${stroke}" stroke-linecap="round" stroke-linejoin="round"/>
  `;
};

export default {
	W: 17,
	H: 16,
	body,
} as _SVGIcon.Icon;
